module.exports = __webpack_public_path__ + "media/files/euroleague/EV_PRIVACY_POLICY.pdf";